import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import imgLoader from '../components/imgLoader'
import AboutSmp from '../views/AboutSmp'
import TrustEconomy from '../views/TrustEconomy'
import Contact from '../views/Contact'

Vue.use(VueRouter)

const routes = [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
        path: '/sequ-health-pro',
        name: 'SEQu-HEALTH-Pro',
        component: imgLoader,
        props: {src: 'sequ-health-pro'}
    },
    {
        path: '/sequ-face',
        name: 'SEQu-FACE',
        component: imgLoader,
        props: {src: 'sequ-face'}
    },
    {
        path: '/sequ-lab',
        name: 'SEQu-LAB',
        component: imgLoader,
        props: {src: 'sequ-lab'}
    },
    {
        path: '/sequ-doc',
        name: 'SEQu-DOC',
        component: imgLoader,
        props: {src: 'sequ-doc'}
    },
    {
        path: '/about',
        name: 'about',
        component: AboutSmp
    },
    {
        path: '/contact',
        name: 'contact',
        component: Contact
    },
    {
        path: '/trust-economy',
        name: 'trust-economy',
        component: TrustEconomy
    }
  ];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
